import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 tracking-wide">精彩集锦</h2>
          <p className="mt-2 text-sm text-foreground-500">热门影视片段、幕后花絮与精彩预告一网打尽</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className={`group cursor-pointer bg-background-50 rounded-lg overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/85 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-background-50/80 backdrop-blur-sm text-foreground-700 whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-700 group-hover:text-primary-400 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{item.desc}</p>
                <div className="flex items-center gap-1 mt-2">
                  <i className="ri-eye-line text-xs text-foreground-400"></i>
                  <span className="text-xs text-foreground-400">{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}